// import React, { useState, useEffect } from "react";
// import { Calendar } from "lucide-react";

// const DateFilter = ({ filter, onFilterChange, onRangeLabel }) => {
//   const { filterType, fromDate, toDate } = filter;

//   const ranges = [
//     { label: "Last 7 Days", value: "last_7_days" },
//     { label: "Last 30 Days", value: "last_30_days" },
//     { label: "Last 90 Days", value: "last_90_days" },
//     { label: "This Month", value: "this_month" },
//     { label: "This Quarter", value: "this_quarter" },
//     { label: "This Year", value: "this_year" },
//     { label: "Custom Range", value: "custom" },
//   ];

//   const [selectedRange, setSelectedRange] = useState(
//     ranges.find((r) => r.value === filterType) || ranges[2]
//   );

//   // send label up to parent
//   useEffect(() => {
//     if (onRangeLabel) {
//       onRangeLabel(selectedRange.label);
//     }
//   }, [selectedRange]);

//   const handleRangeSelect = (value) => {
//     const rangeObj = ranges.find((r) => r.value === value);
//     setSelectedRange(rangeObj);

//     if (value === "custom") {
//       onFilterChange({
//         filterType: value,
//         fromDate,
//         toDate,
//       });
//       return;
//     }

//     onFilterChange({
//       filterType: value,
//       fromDate: "",
//       toDate: "",
//     });
//   };

//   const handleDateChange = (key, value) => {
//     onFilterChange({
//       filterType,
//       fromDate: key === "fromDate" ? value : fromDate,
//       toDate: key === "toDate" ? value : toDate,
//     });
//   };

//   return (
//     <div className="row align-items-center justify-content-between mb-4 gy-3">
//       {/* LEFT TITLE */}
//       <div className="col-12 col-md-6">
//         <h5 className="fw-semibold text-dark mb-1">Signage Vendor Dashboard</h5>
//         <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
//           Track your signage operations, revenue, and performance metrics across brokerages and agents.
//         </p>
//       </div>

//       {/* RIGHT FILTERS */}
//       <div className="col-12 col-md-6">
//         <div className="d-flex flex-wrap justify-content-md-end align-items-center gap-2">

//           {/* Custom Date Range */}
//           {filterType === "custom" && (
//             <>
//               <div className="d-flex flex-column">
//                 <label className="text-muted fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
//                   From
//                 </label>
//                 <input
//                   type="date"
//                   className="form-control shadow-sm"
//                   value={fromDate}
//                   onChange={(e) => handleDateChange("fromDate", e.target.value)}
//                   style={{ borderRadius: "10px", width: "160px" }}
//                 />
//               </div>

//               <div className="d-flex flex-column">
//                 <label className="text-muted fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
//                   To
//                 </label>
//                 <input
//                   type="date"
//                   className="form-control shadow-sm"
//                   value={toDate}
//                   onChange={(e) => handleDateChange("toDate", e.target.value)}
//                   style={{ borderRadius: "10px", width: "160px" }}
//                 />
//               </div>
//             </>
//           )}

//           {/* Dropdown */}
//           <div className="dropdown">
//             <button
//               className="btn btn-light border d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
//               type="button"
//               id="dateRangeDropdown"
//               data-bs-toggle="dropdown"
//               aria-expanded="false"
//               style={{
//                 borderRadius: "10px",
//                 fontWeight: 500,
//                 fontSize: "0.9rem",
//                 minWidth: "160px",
//               }}
//             >
//               <Calendar size={16} className="text-muted" />
//               {selectedRange.label}
//             </button>

//             <ul className="dropdown-menu dropdown-menu-end shadow-sm">
//               {ranges.map((range) => (
//                 <li key={range.value}>
//                   <button
//                     className={`dropdown-item ${filterType === range.value ? "active" : ""}`}
//                     onClick={() => handleRangeSelect(range.value)}
//                   >
//                     {range.label}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default DateFilter;



import React, { useState, useEffect, useMemo } from "react";
import { Calendar } from "lucide-react";

// Date range allowed: last 6 months from today (same as InstallationSummaryReport)
const getDateRangeLimits = () => {
  const today = new Date();
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(today.getMonth() - 6);
  const formatDate = (date: Date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };
  return {
    minDate: formatDate(sixMonthsAgo),
    maxDate: formatDate(today),
  };
};

const DateFilter = ({ filter, onFilterChange, onRangeLabel }) => {
  const { filterType, fromDate, toDate } = filter;

  const dateRangeLimits = useMemo(getDateRangeLimits, []);

  const ranges = [
    { label: "Last 7 Days", value: "last_7_days" },
    { label: "Last 30 Days", value: "last_30_days" },
    { label: "Last 90 Days", value: "last_90_days" },
    { label: "This Month", value: "this_month" },
    { label: "This Quarter", value: "this_quarter" },
    { label: "This Year", value: "this_year" },
    { label: "Custom Range", value: "custom" },
  ];

  const [selectedRange, setSelectedRange] = useState(
    ranges.find((r) => r.value === filterType) || ranges[2]
  );

  // notify parent label
  useEffect(() => {
    onRangeLabel?.(selectedRange.label);
  }, [selectedRange]);

  const handleRangeSelect = (value) => {
    const selected = ranges.find((r) => r.value === value);
    setSelectedRange(selected);

    if (value === "custom") {
      onFilterChange({
        filterType: value,
        fromDate,
        toDate,
      });
    } else {
      onFilterChange({
        filterType: value,
        fromDate: "",
        toDate: "",
      });
    }
  };

  const handleDateChange = (key, value) => {
    onFilterChange({
      filterType,
      fromDate: key === "fromDate" ? value : fromDate,
      toDate: key === "toDate" ? value : toDate,
    });
  };

  // Validate and reset custom dates when outside allowed 6-month range
  useEffect(() => {
    if (filterType !== "custom") return;
    const { minDate, maxDate } = dateRangeLimits;
    let nextFrom = fromDate;
    let nextTo = toDate;
    if (fromDate && (fromDate < minDate || fromDate > maxDate)) nextFrom = "";
    if (toDate && (toDate < minDate || toDate > maxDate)) nextTo = "";
    if (nextFrom !== fromDate || nextTo !== toDate) {
      onFilterChange({ filterType, fromDate: nextFrom, toDate: nextTo });
    }
  }, [filterType, dateRangeLimits, fromDate, toDate, onFilterChange]);

  return (
    <div className="row align-items-center justify-content-between mb-4 gy-3">

      {/* LEFT SIDE TITLE */}
      <div className="col-12 col-md-6">
        <h5 className="text-sizes fw-medium text-gray-900">Signage Vendor Dashboard</h5>
        <p className=" mb-0" style={{ fontSize: "0.9rem" }}>
          Track your signage operations, revenue, and performance metrics across brokerages, agents, and installation jobs.
        </p>
      </div>

      {/* RIGHT SIDE DROPDOWN */}
      <div className="col-12 col-md-6 d-flex justify-content-md-end">

        <div className="d-flex align-items-center gap-2">

          {/* SHOW THESE ONLY WHEN CUSTOM RANGE IS SELECTED */}
          {filterType === "custom" && (
            <>
              <div className="d-flex flex-column">
                <label className="text-muted fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
                  From
                </label>
                <input
                  type="date"
                  className="form-control shadow-sm"
                  value={fromDate}
                  min={dateRangeLimits.minDate}
                  max={dateRangeLimits.maxDate}
                  onChange={(e) => handleDateChange("fromDate", e.target.value)}
                  style={{ borderRadius: "10px", width: "160px" }}
                />
              </div>

              <div className="d-flex flex-column">
                <label className="text-muted fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
                  To
                </label>
                <input
                  type="date"
                  className="form-control shadow-sm"
                  value={toDate}
                  min={dateRangeLimits.minDate}
                  max={dateRangeLimits.maxDate}
                  onChange={(e) => handleDateChange("toDate", e.target.value)}
                  style={{ borderRadius: "10px", width: "160px" }}
                />
              </div>
            </>
          )}

          {/* MAIN DROPDOWN */}
          <div className="dropdown">
            <button
              className="btn btn-light border d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
              type="button"
              id="dateFilter"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                borderRadius: "10px",
                fontWeight: 500,
                fontSize: "0.9rem",
                minWidth: "160px",
              }}
            >
              <Calendar size={16} className="text-muted" />
              {selectedRange.label}
            </button>

            <ul className="dropdown-menu dropdown-menu-end shadow-sm">
              {ranges.map((range) => (
                <li key={range.value}>
                  <button
                    className={`dropdown-item ${filterType === range.value ? "active" : ""}`}
                    onClick={() => handleRangeSelect(range.value)}
                  >
                    {range.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

        </div>
       <style>{`
        .text-sizes {
          font-size: 1.5rem;
        }
          .text-gray-900 {
          color: #101828 ;
        }
       `}</style>
      </div>
    </div>
  );
};

export default DateFilter;
